import React, { ButtonHTMLAttributes, FC } from "react"

const TextButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <button {...props} className={`border-none m-0 p-0 w-auto overflow-visible bg-transparent ${className || ""}`}>
      {children}
    </button>
  )
}

export default TextButton
